module.exports = __webpack_public_path__ + "static/img/flow1.7157d0ce.svg";